import "@preact/signals";
import * as preact from "preact";

import SelectionStore from "stores/SelectionStore";

interface Props {
  model: SelectionStore;
}

class SelectAllView extends preact.Component<Props> {
  inputRef: preact.RefObject<HTMLInputElement> = preact.createRef();

  componentDidMount() {
    this.syncIndeterminate();
  }

  componentDidUpdate() {
    this.syncIndeterminate();
  }

  syncIndeterminate() {
    const input = this.inputRef.current;
    if (!input) return;
    const wholePage = this.props.model.wholePage.value;
    const count = this.props.model.count.value;
    input.indeterminate = !wholePage && count > 0;
  }

  handleChange = (event: Event) => {
    const target = event.currentTarget as HTMLInputElement;
    if (target.checked) {
      this.props.model.selectWholePage();
    } else {
      this.props.model.clearSelection();
    }
  };

  render() {
    const wholePage = this.props.model.wholePage.value;
    const count = this.props.model.count.value;
    const checked = wholePage || count > 0;
    return (
      <>
        <input
          type="checkbox"
          class="selectAll"
          id="selectAllCheckbox"
          checked={checked}
          onChange={this.handleChange}
          ref={this.inputRef}
        />
        <label for="selectAllCheckbox">
          <i class="icon-check"></i>
          <i class="icon-check-empty"></i>
          <i class="icon-check-minus"></i>
        </label>
      </>
    );
  }
}

export default SelectAllView;
